import axios from 'axios'

import {
  AI_CHAT_COMPLETIONS,
  AI_DOWNLOAD_RESULT_DATA, AI_LOGS,
  AI_MODULE_QUERY, AI_MODULE_REPORT, ELITE_AI_CHAT, PSC_INDEX
} from './ConstantService'
import { GlobalService } from './GlobalService'
import {UrlService} from "@/services/UrlService";

export const AiService= {
  async getGeneratedAiDataByModule (params) {
    return await axios.post(AI_MODULE_QUERY.replace('{module}', params.module), {
      query : params.query
    }).then(response => {

      return response.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'GET GENERATED AI DATA BY MODULE SERVICE')
      return false
    })
  },

  async downloadDataResult(query) {
    const response = await axios({
      url:AI_DOWNLOAD_RESULT_DATA,
      method: 'POST',
      responseType: 'blob',
      params : {
        query : query
      }
    });
    if (response.hasOwnProperty('status') && response.status === 200) {
      return response?.data ?? false;
    }
    return false;
  },
  async saveAiKidsLogs(params) {
    return await axios.post(AI_LOGS, params).then(response => {
      return response.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'ADD AI LOGS SERVICE')
      return false
    })
  },
  async getAiKidsLogs(params) {
    const queryString = UrlService.setQueryString(params)
    return await axios.get(AI_LOGS + queryString).then(response => {
      return response.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'GET AI LOGS SERVICE')
      return false
    })
  },
  async getReportsByUniqueNumber(params) {
    return await axios.post(AI_MODULE_REPORT.replace('{module}', params.module), {
      report_numbers : params.report_numbers
    }).then(response => {
      return response.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'GET AI LOGS SERVICE')
      return false
    })
  },
  async sendChatCompletions(params, isOpenAi = false) {
    // delete params.model; // temporary fix to use elite AI instead of open AI
    let chatEndpoint = AI_CHAT_COMPLETIONS;

    if (isOpenAi === false) {
      chatEndpoint = ELITE_AI_CHAT;
      params.stream = false;
      params.model = 'qwen2.5:7b';
    }

    return await axios.post(chatEndpoint, params).then(response => {
      return response.data ?? false
    }).catch(error => {
      return false
    })
  }
}

